import { SvgIcon, type SvgIconProps } from './svgIcon'

export const LocationPinPoint = ({
  width = 12,
  height = 14,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    {...props}>
    <path
      d="M6.04214 0C2.67581 0 0 2.70827 0 6.11545C0 7.77535 0.604214 9.34789 1.81264 10.4836C1.89896 10.571 5.35161 13.7161 5.43793 13.8034C5.78319 14.0655 6.30109 14.0655 6.56004 13.8034C6.64636 13.7161 10.1853 10.571 10.1853 10.4836C11.3938 9.34789 11.998 7.77535 11.998 6.11545C12.0843 2.70827 9.40848 0 6.04214 0ZM6.04214 7.86271C5.09266 7.86271 4.31582 7.07644 4.31582 6.11545C4.31582 5.15445 5.09266 4.36818 6.04214 4.36818C6.99162 4.36818 7.76847 5.15445 7.76847 6.11545C7.76847 7.07644 6.99162 7.86271 6.04214 7.86271Z"
      fill="white"
    />
  </SvgIcon>
)
